import { render, staticRenderFns } from "./Doghnut.vue?vue&type=template&id=11cdb52e&scoped=true"
import script from "./Doghnut.vue?vue&type=script&lang=js"
export * from "./Doghnut.vue?vue&type=script&lang=js"
import style0 from "./Doghnut.vue?vue&type=style&index=0&id=11cdb52e&prod&lang=css"
import style1 from "./Doghnut.vue?vue&type=style&index=1&id=11cdb52e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11cdb52e",
  null
  
)

export default component.exports